import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary capturou um erro:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-surface flex flex-col items-center justify-center p-6 text-center animate-in fade-in">
          <div className="w-16 h-16 rounded-2xl bg-danger/10 text-danger grid place-items-center mb-6 ring-8 ring-danger/5">
            <AlertCircle size={32} />
          </div>
          <h1 className="text-2xl font-800 text-text tracking-tight mb-3">
            Ops! Algo deu errado.
          </h1>
          <p className="text-base text-text-secondary max-w-md mb-8 leading-relaxed">
            Ocorreu um erro inesperado ao exibir esta página. Nossa equipe técnica já foi notificada.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3 w-full max-w-sm">
            <button
              onClick={() => window.location.reload()}
              className="flex-1 min-w-[140px] h-12 bg-accent hover:bg-accent-dark text-white rounded-xl font-600 transition-colors flex items-center justify-center gap-2 shadow-sm"
            >
              <RefreshCw size={18} />
              Tentar Novamente
            </button>
            <button
              onClick={() => { window.location.href = '/'; }}
              className="flex-1 min-w-[140px] h-12 bg-surface hover:bg-surface-hover text-text border border-border rounded-xl font-600 transition-colors"
            >
              Ir para o Início
            </button>
          </div>
          {import.meta.env.DEV && this.state.error && (
            <div className="mt-12 text-left bg-surface-hover border border-border rounded-lg p-4 w-full max-w-3xl overflow-auto text-xs font-mono text-text-muted">
              {this.state.error.toString()}
            </div>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}
